import { IJob, JobStatusEnum } from '~/models';

/** Reads `job_status`, which keeps the pre-cancel `filled` / `open`; `status` reads `cancelled` after any cancel. */
export const isFilledJobCancellation = (job?: Pick<IJob, 'job_status'> | null): boolean =>
  job?.job_status === JobStatusEnum.Filled;
